import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackbarService } from 'src/app/core/services/snackBar/snackbar.service';

import { colorCodes } from 'src/app/core/services/utils/constants';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-remove-profile',
    templateUrl: './remove-profile.component.html',
    styleUrls: ['./remove-profile.component.scss'],
    standalone: false
})
export class RemoveProfileComponent implements OnInit {
  deleteForm: FormGroup | any;
 staticText: any = TranslationService.staticTextData;
  constructor(
    private readonly fb: FormBuilder,
    private readonly _http: HttpClient,
    private readonly _snackBar: SnackbarService,
  ) { }

  ngOnInit(): void {
    this.deleteForm = this.fb.group({
      mobileNumber: ['', [Validators.required, Validators.pattern('^[0-9]{9}$')]],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  deleteAccount(): void {
    this.deleteForm.markAllAsTouched();
    if (this.deleteForm.valid) {
      
      this._http.get<any>('assets/data/remove-profile.json').subscribe(response => {

        this._snackBar.loadSnackBar(response?.message, colorCodes.SUCCESS);
        this.deleteForm.reset();
      });
    }
  }
}
